import React from 'react';

export default function EmailDividerBlock({ props }) {
  return (
    <div style={{ padding: props.padding || '16px 24px' }}>
      <hr style={{
        border: 'none',
        borderTop: `${props.thickness || '1px'} solid ${props.color || '#d6d3d1'}`,
        width: props.width || '100%',
        margin: '0 auto',
      }} />
    </div>
  );
}
